import { PhonePortraitOutline } from "@raresail/react-ionicons";
import styled from "styled-components";
import { TListHook } from "../../@types/common";
import { Button } from "../../components/common/Button";
import { Divider } from "../../components/elements/Elements";
import { API_DEVICES } from "../../constants/apis";
import { DEVICES, ORDER_DEVICE, SELECT, TEXT } from "../../constants/constants";
import { searchFilterField } from "../../constants/options";
import { currencyFormat, stringify } from "../../utils/helpers";
import { openModalForm } from "../../utils/modalUtils";
import { primary5, PRIMARY_COLOR } from "../../constants/colors";

export const useDevicesList = (): TListHook => {
  const filters = [
    searchFilterField,
    {
      field: "brand",
      type: TEXT,
    },
  ];

  return {
    listType: "grid",
    ListItem: DeviceItem,
    title: "BNPL — Buy Now, Pay Later",
    subtitle: "Browse devices available for financing",
    api: API_DEVICES,
    filters,
  };
};

const DeviceItem = ({ data }: { data: any }) => {
  const {
    id,
    name,
    brand,
    model,
    cash_price,
    currency = "UGX",
    description,
    images = [],
    in_stock,
    specs,
  } = data || {};

  const primaryImage = images?.find((img: any) => img.is_primary) || images?.[0];

  return (
    <Wrapper className="flexColumn gap10 whiteBg p15 r10">
      {/* IMAGE */}
      <ImageWrapper className="r10 lightBg flexCenter hidden">
        {primaryImage ? (
          <img
            className="r10"
            src={primaryImage.image}
            alt={name}
            style={{ width: "100%", height: 140, objectFit: "cover" }}
          />
        ) : (
          <div className="flexCenter p20 grey">
            <PhonePortraitOutline fontSize={40} />
          </div>
        )}
      </ImageWrapper>

      {/* HEADER */}
      <div>
        <div className="semiBold textDark font14">{name}</div>
        <div className="font12 grey capitalize">
          {brand} {model && `· ${model}`}
        </div>
      </div>

      {/* PRICE */}
      <div className="font16 bold textDark">{currencyFormat(cash_price, currency)}</div>

      {/* SPECS */}
      {specs && (
        <>
          <Divider />
          <div className="font11 grey ellipsis2">{typeof specs === "string" ? specs : description}</div>
        </>
      )}

      <Divider />

      {/* STOCK + CTA */}
      <div className="flexSpaceCenter">
        <StockBadge inStock={in_stock}>
          {in_stock ? "In Stock" : "Out of Stock"}
        </StockBadge>
        <Button
          className="font12 r20"
          disabled={!in_stock}
          onClick={() => openModalForm({ source: ORDER_DEVICE, state: data })}
        >
          Buy Now, Pay Later
        </Button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const ImageWrapper = styled.div`
  min-height: 140px;
  background: ${primary5};
`;

const StockBadge = styled.div<{ inStock?: boolean }>`
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  color: ${({ inStock }) => (inStock ? "green" : "red")};
  background: ${({ inStock }) => (inStock ? "#e6f9e6" : "#fde8e8")};
`;